import { useQuery } from '@tanstack/react-query';
import type { AuditLog, AuditAction, AuditEntity } from '@stromo/shared';
import { api } from './api';

export interface AuditLogItem extends AuditLog {
  user_name: string | null;
}

export interface AuditFilters {
  entity_type?: AuditEntity;
  entity_id?: number;
  user_id?: number;
  from?: string;
  to?: string;
  limit?: number;
  offset?: number;
}

export function useAuditLog(filters: AuditFilters = {}) {
  return useQuery({
    queryKey: ['audit', filters],
    queryFn: async () => {
      const { data } = await api.get<{ items: AuditLogItem[]; total: number }>('/audit-log', {
        params: filters,
      });
      return data;
    },
  });
}

export function useProjectAudit(projectId: number | undefined, limit = 10) {
  return useQuery({
    queryKey: ['audit', 'project', projectId, limit],
    queryFn: async () => {
      const { data } = await api.get<{ items: AuditLogItem[]; total: number }>(
        `/audit-log/project/${projectId}`,
        { params: { limit } },
      );
      return data;
    },
    enabled: projectId !== undefined,
  });
}

export const ACTION_LABELS: Record<AuditAction, string> = {
  CREATE: 'Angelegt',
  UPDATE: 'Geändert',
  DELETE: 'Gelöscht',
};

export const ENTITY_LABELS: Record<AuditEntity, string> = {
  project: 'Projekt',
  task: 'Aufgabe',
  template: 'Vorlage',
  user: 'Benutzer',
  contact: 'Kontakt',
  section: 'Sektion',
  todo: 'Todo',
};
